module.exports = __webpack_public_path__ + "img/resource-zj-active.4fd6ef6a.png";